import types from 'redux/types';
import { checkTypeValue } from 'helpers';
import Queue from 'helpers/queue';
import {
  changeNameSuccess,
  changeTypeContact,
  fetchCheckImport,
  fetchCheckImportFailed,
  fetchCheckImportSuccess,
  fetchContactServlet,
  fetchContactServletFailed,
  fetchContactServletSuccess,
  fetchImportStorage,
  fetchImportStorageFailed,
  fetchImportStorageSuccess,
  fetchManageContact,
  fetchManageContactSuccess,
  fetchRemoveContact,
  fetchRemoveContactCarrier,
  fetchRemoveContactCarrierFailed,
  fetchRemoveContactCarrierSuccess,
  fetchRemoveContactFailed,
  fetchRemoveContactSuccess,
  fetchSearchContact,
  fetchSearchContactFailed,
  fetchSearchContactSuccess,
  fetchUploadContact,
  fetchUploadContactFailed,
  fetchUploadContactSuccess,
  loadMoreContactFailed,
  loadMoreContactSuccess,
  unmountContactDetail,
  fetchDataConsuming,
  fetchDataConsumingSuccess,
  fetchDataConsumingFailed,
  fetchStartDataConsuming,
  fetchStartDataConsumingSuccess,
  fetchStartDataConsumingFailed,
  fetchCancelImportSuccess,
  baseContactReducer,
  fetchRemoveGroupSuccess,
  fetchLeadFilter,
  fetchLeadFilterSuccess,
  fetchLeadFilterFailed,
  fetchSetLeadCallbackLink,
  fetchStartDataRefreshing,
  fetchStartDataRefreshingSuccess,
  fetchStartDataRefreshingFailed,
  fetchDataRefreshingSuccess,
  fetchDataRefreshingFailed,
  fetchDataRefreshing,
} from 'redux/handleReducers/contact';
import components, { typeUnmounted } from 'consts/components';

const listContactScrubbing = new Queue();

const {
  REQUEST_API_CONTACT_SERVLET,
  REQUEST_API_CONTACT_SERVLET_SUCCESS,
  REQUEST_API_CONTACT_SERVLET_FAILED,
  REQUEST_API_MANAGE_CONTACT_SERVLET,
  REQUEST_API_MANAGE_CONTACT_SERVLET_SUCCESS,
  REQUEST_CLEAR_CONTACT_SERVLET_SUCCESS,
  REQUEST_API_GET_CONTACT_BELONG_TO,
  REQUEST_API_GET_CONTACT_BELONG_TO_SUCCESS,
  REQUEST_REMOVE_CONTACT,
  REQUEST_REMOVE_CONTACT_SUCCESS,
  REQUEST_REMOVE_CONTACT_FAILED,
  REQUEST_CLEAR_CONTACT_DETAIL,
  REQUEST_GET_EDIT_CONTACT,
  REQUEST_GET_EDIT_CONTACT_FAILED,
  REQUEST_GET_EDIT_CONTACT_SUCCESS,
  REQUEST_CLEAR_EDIT_CONTACT,
  REQUEST_SCRUB_CONTACT,
  REQUEST_SCRUB_CONTACT_FAILED,
  REQUEST_SCRUB_CONTACT_SUCCESS,
  CLEAR_SCRUB_CONTACT,
  REQUEST_GETALL_LANDLINE_CHECK,
  REQUEST_GETALL_LANDLINE_CHECK_FAILED,
  REQUEST_GETALL_LANDLINE_CHECK_SUCCESS,
  REQUEST_CHECK_SCRUB,
  REQUEST_CHECK_SCRUB_SUCCESS,
  REQUEST_CHECK_SCRUB_CANCEL,
  REQUEST_CANCEL_LANDLINE_SUCCESS,
  REQUEST_REMOVE_GROUP,
  REQUEST_REMOVE_GROUP_FAILED,
  REQUEST_REMOVE_GROUP_SUCCESS,
  REQUEST_UPLOAD_LIST_CONTACT,
  REQUEST_UPLOAD_LIST_CONTACT_FAILED,
  REQUEST_UPLOAD_LIST_CONTACT_SUCCESS,
  REQUEST_GET_PREVIEW_LINE,
  REQUEST_GET_PREVIEW_LINE_FAILED,
  REQUEST_GET_PREVIEW_LINE_SUCCESS,
  REQUEST_HEADER_FIELD,
  REQUEST_HEADER_FIELD_SUCCESS,
  REQUEST_HEADER_FIELD_FAILED,
  REQUEST_DELETE_FILE_SUCCESS,
  REQUEST_IMPORT_FROM_STORAGE,
  REQUEST_IMPORT_FROM_STORAGE_SUCCESS,
  REQUEST_IMPORT_FROM_STORAGE_FAILED,
  REQUEST_IMPORT_LIST_CONTACT,
  REQUEST_IMPORT_LIST_CONTACT_FAILED,
  REQUEST_IMPORT_LIST_CONTACT_SUCCESS,
  REQUEST_CHECK_STATUS_IMPORT,
  REQUEST_CHECK_STATUS_IMPORT_SUCCESS,
  REQUEST_CHECK_STATUS_IMPORT_FAILED,
  REQUEST_CHECK_CANCELLED_STATUS_IMPORT,
  REQUEST_CANCEL_IMPORT_SUCCESS,
  REQUEST_GET_PROCESS_ID_IMPORT,
  REQUEST_GET_PROCESS_ID_IMPORT_SUCCESS,
  REQUEST_GET_PROCESS_ID_IMPORT_FAILED,
  REQUEST_CLEAR_IMPORT_CONTACT,
  REQUEST_DELETE_CONTACT_BY_CARRIER,
  REQUEST_DELETE_CONTACT_BY_CARRIER_SUCCESS,
  REQUEST_DELETE_CONTACT_BY_CARRIER_FAILED,
  REQUEST_SEARCH_CONTACT_SERVLET,
  REQUEST_SEARCH_CONTACT_SERVLET_SUCCESS,
  REQUEST_SEARCH_CONTACT_SERVLET_FAILED,
  // REQUEST_LOAD_MORE_CONTACT,
  REQUEST_LOAD_MORE_CONTACT_SUCCESS,
  REQUEST_LOAD_MORE_CONTACT_FAILED,
  CHANGE_TYPE_CONTACT,
  // REQUEST_CHANGE_NAME_CONTACT,
  REQUEST_CHANGE_NAME_CONTACT_SUCCESS,
  // REQUEST_CHANGE_NAME_CONTACT_FAILED,
  // CLEAR_INFO_CONTACT,
  REQUEST_GET_DATA_CONSUMING,
  REQUEST_GET_DATA_CONSUMING_SUCCESS,
  REQUEST_GET_DATA_CONSUMING_FAILED,
  REQUEST_START_DATA_CONSUMING,
  REQUEST_START_DATA_CONSUMING_SUCCESS,
  REQUEST_START_DATA_CONSUMING_FAILED,

  REQUEST_GET_DATA_REFRESHING,
  REQUEST_GET_DATA_REFRESHING_SUCCESS,
  REQUEST_GET_DATA_REFRESHING_FAILED,
  REQUEST_START_DATA_REFRESHING,
  REQUEST_START_DATA_REFRESHING_SUCCESS,
  REQUEST_START_DATA_REFRESHING_FAILED,

  REQUEST_SAVE_LEAD_FILTER,
  REQUEST_SAVE_LEAD_FILTER_SUCCESS,
  REQUEST_SAVE_LEAD_FILTER_FAILED,

  REQUEST_SET_LEAD_CALLBACK_LINK_SUCCESS,
} = types;

const initialValues = {
  ...baseContactReducer(),
};

export default (state, actions) => {
  // Fix case "switch to large case"
  const listAction = {
    [REQUEST_SAVE_LEAD_FILTER]: () => fetchLeadFilter(actions, state),
    [REQUEST_SAVE_LEAD_FILTER_SUCCESS]: () => fetchLeadFilterSuccess(actions, state),
    [REQUEST_SAVE_LEAD_FILTER_FAILED]: () => fetchLeadFilterFailed(actions, state),

    [REQUEST_START_DATA_CONSUMING]: () => fetchStartDataConsuming(actions, state),
    [REQUEST_START_DATA_CONSUMING_SUCCESS]: () => fetchStartDataConsumingSuccess(actions, state),
    [REQUEST_START_DATA_CONSUMING_FAILED]: () => fetchStartDataConsumingFailed(actions, state),

    [REQUEST_GET_DATA_CONSUMING]: () => fetchDataConsuming(actions, state),
    [REQUEST_GET_DATA_CONSUMING_SUCCESS]: () => fetchDataConsumingSuccess(actions, state),
    [REQUEST_GET_DATA_CONSUMING_FAILED]: () => fetchDataConsumingFailed(actions, state),

    [REQUEST_START_DATA_REFRESHING]: () => fetchStartDataRefreshing(actions, state),
    [REQUEST_START_DATA_REFRESHING_SUCCESS]: () => fetchStartDataRefreshingSuccess(actions, state),
    [REQUEST_START_DATA_REFRESHING_FAILED]: () => fetchStartDataRefreshingFailed(actions, state),

    [REQUEST_GET_DATA_REFRESHING]: () => fetchDataRefreshing(actions, state),
    [REQUEST_GET_DATA_REFRESHING_SUCCESS]: () => fetchDataRefreshingSuccess(actions, state),
    [REQUEST_GET_DATA_REFRESHING_FAILED]: () => fetchDataRefreshingFailed(actions, state),

    [REQUEST_CHANGE_NAME_CONTACT_SUCCESS]: () => changeNameSuccess(actions, state),
    [REQUEST_REMOVE_GROUP]: () => ({ ...state }),
    [REQUEST_REMOVE_GROUP_SUCCESS]: () => fetchRemoveGroupSuccess(actions, state),
    [REQUEST_HEADER_FIELD]: () => ({ ...state }),
    [REQUEST_HEADER_FIELD_FAILED]: () => ({ ...state }),
    [REQUEST_GET_PREVIEW_LINE]: () => ({ ...state }),
    [REQUEST_GET_PROCESS_ID_IMPORT]: () => ({ ...state }),
    [REQUEST_DELETE_CONTACT_BY_CARRIER]: () => fetchRemoveContactCarrier(actions, state),
    [REQUEST_DELETE_CONTACT_BY_CARRIER_SUCCESS]: () =>
      fetchRemoveContactCarrierSuccess(actions, state),
    [REQUEST_DELETE_CONTACT_BY_CARRIER_FAILED]: () =>
      fetchRemoveContactCarrierFailed(actions, state),
    [REQUEST_CLEAR_IMPORT_CONTACT]: () => ({
      ...state,
      processIdImport: undefined,
      itemRunningImport: {},
      previewLine: [],
    }),
    [REQUEST_CLEAR_IMPORT_CONTACT]: () => ({
      ...state,
      processIdImport: undefined,
      itemRunningImport: {},
      previewLine: [],
    }),
    [REQUEST_GET_PROCESS_ID_IMPORT_SUCCESS]: () => ({
      ...state,
      processIdImport: actions.data,
    }),
    [REQUEST_GET_PROCESS_ID_IMPORT_FAILED]: () => ({
      ...state,
      errorGetProcessId: actions.error,
    }),
    [REQUEST_IMPORT_FROM_STORAGE]: () => fetchImportStorage(actions, state),
    [REQUEST_IMPORT_FROM_STORAGE_SUCCESS]: () => fetchImportStorageSuccess(actions, state),
    [REQUEST_IMPORT_FROM_STORAGE_FAILED]: () => fetchImportStorageFailed(actions, state),

    [REQUEST_CHECK_STATUS_IMPORT]: () => fetchCheckImport(actions, state),
    [REQUEST_CHECK_STATUS_IMPORT_SUCCESS]: () => fetchCheckImportSuccess(actions, state),
    [REQUEST_CHECK_STATUS_IMPORT_FAILED]: () => fetchCheckImportFailed(actions, state),
    [REQUEST_CHECK_CANCELLED_STATUS_IMPORT]: () => fetchCancelImportSuccess(actions, state),
    [REQUEST_CANCEL_IMPORT_SUCCESS]: () => fetchCancelImportSuccess(actions, state),

    [REQUEST_IMPORT_LIST_CONTACT]: () => ({
      ...state,
      isUploading: true,
    }),
    [REQUEST_IMPORT_LIST_CONTACT_SUCCESS]: () => ({
      ...state,
      isUploading: false,
      processIdImport: actions.processIdImport,
      itemRunningImport: actions.itemRunningImport || state.itemRunningImport,
    }),
    [REQUEST_IMPORT_LIST_CONTACT_FAILED]: () => ({
      ...state,
      errorImport: actions.error,
      isUploading: false,
    }),
    [REQUEST_UPLOAD_LIST_CONTACT]: () => fetchUploadContact(actions, state),
    [REQUEST_UPLOAD_LIST_CONTACT_SUCCESS]: () => fetchUploadContactSuccess(actions, state),
    [REQUEST_UPLOAD_LIST_CONTACT_FAILED]: () => fetchUploadContactFailed(actions, state),
    [REQUEST_GET_PREVIEW_LINE_SUCCESS]: () => ({
      ...state,
      previewLine: actions.data,
    }),
    [REQUEST_GET_PREVIEW_LINE_FAILED]: () => ({
      ...state,
    }),
    [REQUEST_HEADER_FIELD_SUCCESS]: () => ({
      ...state,
      headerField: actions.data,
    }),
    [REQUEST_DELETE_FILE_SUCCESS]: () => ({
      ...state,
      previewLine: [],
    }),
    [REQUEST_REMOVE_GROUP_FAILED]: () => ({
      ...state,
      errorRemove: actions.error,
    }),
    [REQUEST_GETALL_LANDLINE_CHECK]: () => {
      return {
        ...state,
        isGetAllLandline: true,
      };
    },
    [REQUEST_GETALL_LANDLINE_CHECK_SUCCESS]: () => {
      return {
        ...state,
        progressId: actions.progressId,
        isGetAllLandline: false,
        listAllRunningLandline: actions.data,
      };
    },
    [REQUEST_GETALL_LANDLINE_CHECK_FAILED]: () => ({
      ...state,
      isGetAllLandline: false,
    }),
    [REQUEST_CANCEL_LANDLINE_SUCCESS]: () => {
      listContactScrubbing.removeFromQueue(actions.groupId);
      return {
        ...state,
        listContactScrubbing: listContactScrubbing.queue,
      };
    },
    [REQUEST_SCRUB_CONTACT]: () => {
      return {
        ...state,
        isScrubbing: true,
      };
    },
    [REQUEST_SCRUB_CONTACT_SUCCESS]: () => ({
      ...state,
      isScrubbing: false,
      progressId: actions.data,
    }),
    [REQUEST_SCRUB_CONTACT_FAILED]: () => ({
      ...state,
      isScrubbing: false,
      errorScrub: actions.error,
      progressId: undefined,
    }),
    [REQUEST_CHECK_SCRUB]: () => {
      listContactScrubbing.pushToQueue(actions.groupId);
      return {
        ...state,
        isScrubbing: true,
        listContactScrubbing: listContactScrubbing.queue,
      };
    },
    [REQUEST_CHECK_SCRUB_SUCCESS]: () => {
      listContactScrubbing.removeFromQueue(actions.groupId);
      return {
        ...state,
        isScrubbing: false,
        listContactScrubbing: listContactScrubbing.queue,
        listAllRunningLandline: [],
        contacts: actions.contacts || state.contacts,
        total: actions.total || state.total,
      };
    },
    [REQUEST_CHECK_SCRUB_CANCEL]: () => {
      listContactScrubbing.removeFromQueue(actions.groupId);
      return {
        ...state,
        isScrubbing: false,
        listContactScrubbing: listContactScrubbing.queue,
      };
    },
    [CLEAR_SCRUB_CONTACT]: () => ({
      ...state,
      isScrubbing: false,
      progressId: undefined,
    }),
    [REQUEST_GET_EDIT_CONTACT]: () => ({
      ...state,
      isEditGetting: true,
    }),
    [REQUEST_GET_EDIT_CONTACT_SUCCESS]: () => ({
      ...state,
      isEditGetting: false,
      dataEditContact: actions.data,
    }),
    [REQUEST_GET_EDIT_CONTACT_FAILED]: () => ({
      ...state,
      isEditGetting: false,
      errorEditContact: actions.error,
    }),
    [REQUEST_CLEAR_EDIT_CONTACT]: () => ({
      ...state,
      isEditGetting: false,
      dataEditContact: null,
    }),
    [REQUEST_REMOVE_CONTACT]: () => fetchRemoveContact(actions, state),
    [REQUEST_REMOVE_CONTACT_SUCCESS]: () => fetchRemoveContactSuccess(actions, state),
    [REQUEST_REMOVE_CONTACT_FAILED]: () => fetchRemoveContactFailed(actions, state),
    [REQUEST_API_GET_CONTACT_BELONG_TO]: () => ({
      ...state,
      isFetchingBelongTo: true,
    }),
    [REQUEST_API_GET_CONTACT_BELONG_TO_SUCCESS]: () => ({
      ...state,
      isFetchingBelongTo: false,
      listContactBelong: actions.data,
    }),
    [CHANGE_TYPE_CONTACT]: () => changeTypeContact(actions, state),
    [REQUEST_API_MANAGE_CONTACT_SERVLET]: () => fetchManageContact(actions, state),
    [REQUEST_API_MANAGE_CONTACT_SERVLET_SUCCESS]: () => fetchManageContactSuccess(actions, state),

    [REQUEST_API_CONTACT_SERVLET]: () => fetchContactServlet(actions, state),
    [REQUEST_API_CONTACT_SERVLET_SUCCESS]: () => fetchContactServletSuccess(actions, state),
    [REQUEST_API_CONTACT_SERVLET_FAILED]: () => fetchContactServletFailed(actions, state),

    [REQUEST_CLEAR_CONTACT_SERVLET_SUCCESS]: () => ({ isFetching: true }),
    [REQUEST_SEARCH_CONTACT_SERVLET]: () => fetchSearchContact(actions, state),
    [REQUEST_SEARCH_CONTACT_SERVLET_SUCCESS]: () => fetchSearchContactSuccess(actions, state),
    [REQUEST_SEARCH_CONTACT_SERVLET_FAILED]: () => fetchSearchContactFailed(actions, state),

    [REQUEST_LOAD_MORE_CONTACT_SUCCESS]: () => loadMoreContactSuccess(actions, state),
    [REQUEST_LOAD_MORE_CONTACT_FAILED]: () => loadMoreContactFailed(actions, state),

    [typeUnmounted(components.contactDetail)]: () => unmountContactDetail(actions, state),
    [REQUEST_CLEAR_CONTACT_DETAIL]: () => unmountContactDetail(actions, state),

    [REQUEST_SET_LEAD_CALLBACK_LINK_SUCCESS]: () => fetchSetLeadCallbackLink(actions, state),
  };

  if (checkTypeValue(state, 'undefined')) {
    return initialValues;
  }
  if (listAction[actions.type]) {
    return listAction[actions.type]();
  }
  return state;
};
